import Grid from '@mui/material/Grid'

import { AlarmIcon, CloseIcon } from 'assets/icons'
import IconButton from 'components/buttons/IconButton'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { ChangeEvent, useState } from 'react'
import { EventDoc, EventNote, EventReminder } from 'types/api/changes'
import Checkbox from '@mui/material/Checkbox'
import { theme } from 'theme'
import { Typography } from '@mui/material'
import { TextWithLinks } from 'components/TextWithLinks'
import ImageDetailsDialog from 'components/dialogs/ImageDetailsDialog'
import ChangeTextDialog from 'components/dialogs/ChangeTextDialog'
import { s } from '@fullcalendar/core/internal-common'
import { t } from 'i18next'
import {
  appendNoteWithMetaData,
  clearNote,
  unPackMetaData
} from 'utils/note_meta_data'
import Logger from 'services/Logger'

interface NotesListProps {
  notes: EventNote[]
  setNotes?: (notes: EventNote[]) => void
  checkable?: boolean
  disableDelete?: boolean
  isUiBlocked?: boolean
  event?: EventDoc
}

export default function NotesList(props: NotesListProps) {
  const { notes, setNotes } = props
  const removeNote = (noteToRemove: EventNote) => {
    const withoutNote = notes.filter(
      (note) => note.NoteID != noteToRemove.NoteID
    )
    if (setNotes) setNotes(withoutNote)
  }

  const [data, setData] = useState<string | undefined>()
  const [open, setOpen] = useState(false)
  const [changeNote, setChangeNote] = useState<EventNote | undefined>(undefined)

  if (!notes || typeof notes === 'string') return <></>

  return (
    <>
      {notes
        ?.filter((note) => {
          Logger.blue('Notes:Filter', clearNote(note.Note).trim().length)
          return clearNote(note.Note).trim().length !== 0
        })
        ?.map((note, index) => {
          return (
            <Grid
              container
              key={note.NoteID}
              direction={'row'}
              display={'flex'}
              wrap={'nowrap'}
              columnGap={2}
              justifyContent={'space-between'}
            >
              {props.checkable ? (
                <Checkbox
                  sx={{
                    padding: 0,
                    '&.Mui-checked': {
                      color: theme.palette.input.placeholder
                    }
                  }}
                  size={'medium'}
                  checked={note.Status != 1}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    const updatedNotes = [...props.notes]
                    updatedNotes[index].Status = event.target.checked ? 2 : 1
                    if (props.setNotes) props.setNotes(updatedNotes)
                  }}
                />
              ) : (
                <></>
              )}
              <PopupSectionRow
                title={
                  <span
                    style={{
                      width: '282px',
                      display: 'block',
                      overflowX: 'hidden',
                      overflowY: 'auto',
                      whiteSpace: 'pre-wrap',
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      color: note.FileBytes ? 'blue' : undefined,
                      cursor: note.FileBytes ? 'pointer' : 'default',
                      textDecoration:
                        note.Status != 1
                          ? 'line-through'
                          : note.FileBytes
                          ? 'underline'
                          : 'none'
                    }}
                  >
                    <TextWithLinks text={clearNote(note.Note)} />
                  </span>
                }
                action={
                  note.FileBytes
                    ? () => {
                        if (note.FileBytes) {
                          // show dialog here
                          setData(note.FileBytes)
                          setOpen(true)
                        }
                      }
                    : () => {
                        if (!props.isUiBlocked) setChangeNote(note)
                      }
                }
                value={
                  !props.disableDelete ? (
                    <IconButton
                      size="xs"
                      onClick={() => {
                        removeNote(note)
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : (
                    <></>
                  )
                }
              />
            </Grid>
          )
        })}
      <ImageDetailsDialog
        open={open}
        onClose={() => {
          setOpen(false)
          setTimeout(() => {
            setData(undefined)
          }, 500)
        }}
        imageBase64={data ?? ''}
      />
      {changeNote && (
        <ChangeTextDialog
          open={changeNote.NoteID != undefined}
          setOpen={(b: boolean) => {
            if (!b) setChangeNote(undefined)
          }}
          title={''}
          text={clearNote(changeNote.Note)}
          onApprove={(newNote: string) => {
            changeNote.Note = appendNoteWithMetaData(
              newNote,
              unPackMetaData(props.event)
            )

            if (setNotes) setNotes([...notes])
            setChangeNote(undefined)
          }}
          placeholder={''}
        />
      )}
    </>
  )
}
